import axios from 'axios';

export function getProgramCustomStyles(course_id) {
  return axios.get(`v3/courses/${course_id}/custom_styles`);
}

export function createProgramCustomStyles(course_id, params) {
  return axios.post(`v3/courses/${course_id}/custom_styles`, params);
}

export function updateProgramCustomStyles(course_id, params) {
  return axios.put(`v3/courses/${course_id}/custom_styles`, params);
}
